'use client'

import React, { useState } from 'react'

import { JoinUsNowModal } from 'Components/Blocks/Modals'
import { Button, Column, Text } from 'Components/UI'

import { useAppContext } from 'Services/AppContext'

function RSVPPage() {
  const { me } = useAppContext()

  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  return (
    <Column alignCenter fullHeight fullWidth gap={7} justifyEnd>
      {!me && (
        <>
          <Button large onClick={() => setJoinUsModalModalOpened(true)}>
            Contact Emajin Team
          </Button>

          <JoinUsNowModal
            isOpened={joinUsModalModalOpened}
            onClose={() => setJoinUsModalModalOpened(false)}
          />
        </>
      )}

      <Text body2 center disabled>
        Bookings can be done via membership app.
      </Text>
    </Column>
  )
}

export default RSVPPage
